import useGroup from '@core/services/business/group/useGroup';
import axios from 'axios';
import defaultConfig from '../../defaultConfig';

const axiosIns = axios.create( {
  baseURL: defaultConfig.businessService,
  headers: {
    "Content-Type": "application/json",
    crossdomain: true,
    "Access-Control-Allow-Origin": "*",
  }
} );

const { group } = useGroup( axiosIns, {} );
export default group;
